import { serviceActions } from '../state/modules/service';
import { Dispatch } from 'redux';
import { useP4ToastController } from '../views/system/NotificationsArea';

import { AlertType } from '../graphql/schema/p4types';

export const useCheckPopUpBlockerFunction = () => {
  const { dispatchSimpleToast } = useP4ToastController();

  return (url: string, name?: string, specs?: string) => {
    const newWin = window.open(url, name, specs);
    if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
      dispatchSimpleToast(
        'Popups blocked',
        'Content could not be displayed - Update your browser settings to allow Popups',
        AlertType.Warning
      );
    } else {
      return newWin;
    }
  };
};

/**
 * @deprecated - Make use of 'useCheckPopUpBlockerFunction' above instead.
 * This function attempts to open a new window/tab with the specified url & pops up a notification if the browser prevents it to warn the user.
 * It uses the deprecated redux-based method of submitting notifications, it should not be used for new code.
 */
export default function CheckPopUpBlockerFunction(
  { dispatch }: { dispatch: Dispatch<any> },
  url: string,
  name?: string,
  specs?: string
): Window | undefined {
  const newWin = window.open(url, name, specs);

  if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
    dispatch(
      serviceActions.genericAlert(
        'Popups blocked',
        'Content could not be displayed - Update your browser settings to allow Popups'
      )
    );
  } else {
    return newWin;
  }
}

export function openFormActionInNewTab(dispatch, url) {
  CheckPopUpBlockerFunction({ dispatch }, `${window.location.origin}${url}`, '_blank');
}
